import { BadgeCheck } from "lucide-react";
import { getTypeById } from "@commonqr/shared/config/identityTypes";

interface VerifiedBadgeProps {
  isVerified: boolean;
  profileType?: string;
}

export function VerifiedBadge({ isVerified, profileType = "personal" }: VerifiedBadgeProps) {
  if (!isVerified) return null;
  const identityType = getTypeById(profileType);
  const label = identityType?.verifiedBadgeLabel ?? "Verified";
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-xs font-semibold text-blue-700">
      <BadgeCheck className="h-3.5 w-3.5" />
      {label}
    </span>
  );
}